import { GROUPED_PRIVILEGES } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { EventsPage } from '@/pages/events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/events/')({
  beforeLoad: () =>
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.eventList }),
  component: EventsPage,
});
